import { Group, UnstyledButton } from "@mantine/core";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "#shared/routes";
import { Image } from "#shared/view/components/Image";
import { Text } from "#shared/view/components/Text";

import classes from "./Header.module.css";

export const Brand = ({ ...props }) => {
  const navigate = useNavigate();

  return (
    <UnstyledButton {...props} onClick={() => navigate(ROUTES.partner)}>
      <Group gap="xs" className={classes.logo}>
        <Image src="/fabera-logo.png" className={classes.image} />

        <Text fw="700" fz="24px" lh={0} v-align="baseline">
          Fabera
        </Text>
      </Group>
    </UnstyledButton>
  );
};
